const initialState = {
  events: null,
  eventRegions: null,
  checklist: null,
  avaliableSegments: null,
};

export default initialState;
